export default "__VITE_ASSET__DOtxP$9Q__"